import * as Sentry from '@sentry/react';
import { init, makeBrowserOfflineTransport, makeFetchTransport } from "@sentry/react";
import React from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

init({
    enabled: false,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: `${process.env.REACT_APP_VER}.${process.env.REACT_APP_ENV}`,
    environment:  (process.env.REACT_APP_ENV || process.env.NODE_ENV) + (process.env.REACT_APP_MODE ? "|app" : "") + `@${process.env.REACT_APP_VER}`,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.breadcrumbsIntegration({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        xhr: true,
      }),
      Sentry.browserApiErrorsIntegration({
        setTimeout: true,
        setInterval: true,
        requestAnimationFrame: true,
        XMLHttpRequest: true,
        eventTarget: true,
      }),
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration(),
      Sentry.contextLinesIntegration(),
      Sentry.dedupeIntegration(),
      Sentry.replayIntegration(),
      Sentry.sessionTimingIntegration(),
    ],
    transport:makeBrowserOfflineTransport(makeFetchTransport),
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    autoSessionTracking: true,
    sampleRate: 1, // 错误事件的采样率
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      //
      /Navigation aborted/,
      /Navigation cancelled/,
      /Avoided redundant navigation/,
      /\[vue-clipboards\] Invalid value\./,
      /window\.bannerNight/,
      /Redirected when going from/,
      /Non-Error promise rejection captured with value: cancel/,
      "登入已过期",
      /Non-Error promise rejection captured/
    ]
});


export { };

// export const initSentry = (Vue, router) => {
//   Sentry.init({
//     Vue,
//     dsn: process.env.REACT_APP_SENTRY_DSN,
//     release: `${process.env.REACT_APP_VER}.${process.env.REACT_APP_ENV}`,
//     environment:  (process.env.REACT_APP_ENV || process.env.NODE_ENV) + (process.env.REACT_APP_MODE ? "|app" : "") + `@${process.env.REACT_APP_VER}`,
//     integrations: [
//       new Sentry.BrowserTracing({
//         routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       }),
//       new Sentry.Replay(),
//     ],
//     transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 0.3,
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//     ignoreErrors: [
//       //
//       /Navigation aborted/,
//       /Navigation cancelled/,
//       /Avoided redundant navigation/,
//       /\[vue-clipboards\] Invalid value\./,
//       /window\.bannerNight/,
//       /Redirected when going from/,
//       /Non-Error promise rejection captured with value: cancel/,
//       "登入已过期",
//       /Non-Error promise rejection captured/
//     ]
//   });
// };